import type {FC} from 'react';
import {
  Create,
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  List,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

const TYPES = [
  {id: 'ALS', name: 'ALS'},
  {id: 'SLAM', name: 'SLAM'},
];

export const LidarTechnologyList: FC = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="type" />
      <TextField source="description" />
      <DateField source="createdAt" label="Created" />
      <DateField source="updatedAt" label="Updated" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const LidarTechnologyEdit: FC = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <SelectInput source="type" choices={TYPES} validate={[required()]} />
      <TextInput source="description" validate={[]} />
      <NumberInput source="height" validate={[]} />
      <NumberInput source="speed" validate={[]} />
      <NumberInput source="overlapPercentage" validate={[]} />
    </SimpleForm>
  </Edit>
);

export const LidarTechnologyCreate: FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <SelectInput source="type" choices={TYPES} validate={[required()]} />
      <TextInput source="description" validate={[required()]} />
      <NumberInput source="height" validate={[]} />
      <NumberInput source="speed" validate={[]} />
      <NumberInput source="overlapPercentage" validate={[]} />
    </SimpleForm>
  </Create>
);
